/*
 * @Description: VIP管理页面设置路由
 */
import Layout from '@/layout/pcHome.vue'
export default [
	{
		path: '/AccountInfo',
		component: Layout,
		redirect: '/AccountInfo/agencyInfo',
		children: [
			{
				path: 'agencyInfo',
				component: () => import(/* webpackChunkName: "agencyInfo" */ '@/views/accountInfo/agencyInfo/index.vue'),
				name: 'agencyInfo',
				meta: { title: '机构信息' },
			},
			{
				path: 'personalSettings',
				component: () => import(/* webpackChunkName: "personalSettings" */ '@/views/accountInfo/personalSettings/index.vue'),
				name: 'personalSettings',
				meta: { title: '个人设置' },
			}
		]
	}
]
